export var clip=function(o,r){return void 0===r&&(r=6),parseFloat(o.toFixed(r))};